module.exports = __webpack_public_path__ + "img/heavy-tool.df550e56.png";